import CampusPage from './CampusPage';
import { CAMPUS_DATA } from '../../data/campus';

export default function MasCuautla() {
  return <CampusPage campus={CAMPUS_DATA.cuautla} />;
}
